<template>
  <div class="butler">
    <p>
      <el-checkbox v-model="accountDialog.isOwnAllAccount">拥有管理所有账号权</el-checkbox>
    </p>
    <div class="add-item">
      <div class="item-hd">
        <span>账号</span>
        <el-select
          v-model="accountDialog.account"
          multiple
          filterable
          placeholder="请选择账号"
          size="small"
          @change="getAccount"
          @remove-tag="removeTag"
        >
          <el-option v-for="(item, index) in accountDialog.accountOptions" :key="index" :label="item.loginName" :value="item.opId">
          </el-option>
        </el-select>
        <el-button type="primary" class="add" @click="addAccountFn">添加</el-button>
      </div>
      <div class="item-bd" v-if="accountDialog.accountTags && accountDialog.accountTags.length">
        <el-tag
          :key="index"
          v-for="(tag, index) in accountDialog.accountTags"
          closable
          :disable-transitions="false"
          @close="handleCloseTag(tag, 'accountTags')"
        >
          {{ tag.loginName }}
        </el-tag>
      </div>
    </div>
  </div>
</template>
<script>
import { queryChannelManager } from '@/api/sysmana.model'
export default {
  name: 'butler',
  props: ['butlerData', 'accountOptions', 'butlerVisible'],
  data() {
    return {
      accountDialog: {
        isOwnAllAccount: false,
        account: [],
        accountOptions: [],
        accountTags: []
        // memberDialog: '',
        // memberOptions: [],
        // memberTags: [],
        // groupDialog: '',
        // groupOptions: [],
        // groupTags: []
      },
      addAccount: [],
      butlerDataManager: {}
    }
  },
  watch: {
    butlerVisible: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.queryData()
          this.getChannelManager()
        }
      },
      deep: true
    }
  },
  created() {},
  methods: {
    queryData() {
      this.butlerDataManager = JSON.parse(JSON.stringify(this.butlerData))
      this.accountDialog.accountOptions = JSON.parse(JSON.stringify(this.accountOptions))
    },
    addAccountFn() {
      this.addAccount.forEach((id) => {
        this.accountDialog.accountOptions.forEach((item) => {
          if (id === item.opId) {
            const tagsArr = this.accountDialog.accountTags.map((i) => i.opId).join(',')
            if (tagsArr.includes(id)) {
              return false
            } else {
              this.accountDialog.accountTags.push({ ...item })
            }
          }
        })
      })
      this.submitParams()
    },
    submitParams() {
      const submitAccountInfo = {
        userId: this.butlerDataManager.userId,
        allManager: this.accountDialog.isOwnAllAccount ? 1 : 0,
        managerIds: this.accountDialog.accountTags.map((i) => i.opId).join(',')
      }
      return submitAccountInfo
    },
    removeTag(info) {
      this.accountDialog.accountTags.forEach((item, index) => {
        if (info === item.opId) {
          this.accountDialog.accountTags.splice(index, 1)
        }
      })
      this.submitParams()
    },
    getAccount(info) {
      this.addAccount = info
    },
    getChannelManager() {
      this.accountDialog.accountTags = []
      queryChannelManager({
        userId: this.butlerDataManager.userId,
        deptId: ''
      }).then((data) => {
        if (data) {
          const { channelManagers, allManager } = data
          this.$nextTick(() => {
            this.accountDialog.accountTags = channelManagers
            this.accountDialog.isOwnAllAccount = allManager === '1' // 1为拥有管理权  0 为没有
            this.accountDialog.account = channelManagers && channelManagers.length && channelManagers.map((i) => i.managerName)
          })
        }
      })
    },
    handleCloseTag(tag, type) {
      if (type === 'accountTags') {
        this.accountDialog.accountTags.splice(this.accountDialog.accountTags.indexOf(tag), 1)
        this.accountDialog.account.splice(this.accountDialog.account.indexOf(tag), 1)
        this.addAccount.splice(this.addAccount.indexOf(tag.opId), 1)
        this.submitParams()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.el-input) {
  width: 300px;
}
.addCount {
  margin-bottom: 10px;
  overflow: hidden;
}
.account-list {
  overflow: hidden;
  .el-table {
    margin-top: 0;
  }
}
.butler {
  margin-top: -20px;
  max-height: 500px;
  overflow: auto;
}
.add-item {
  margin-top: 10px;
  .item-hd {
    span {
      display: inline-block;
      margin-right: 10px;
    }
    .add {
      margin-left: 10px;
    }
  }
  .item-bd {
    margin-top: 10px;
    padding: 10px;
    border: 1px solid #dcdfe6;
    border-radius: 5px;
  }
}
.el-tag {
  margin: 0 5px 5px 0;
}
</style>
